<template>
 <div class="LH infinite-table-LH" v-if="this.tableData.length">
    <h3>单倍群：</h3>
	<el-table :data='haplogroups' stripe style="width: 100%" max-height="300">
		<el-table-column prop="group" label="单倍群" min-width="90">
		</el-table-column>
		<el-table-column prop="about" label="关于单倍群" min-width="155">
		</el-table-column>
		<el-table-column prop="startTime" label="起源时间" min-width="105">
		</el-table-column>
		<el-table-column prop="area" label="主要分布" min-width="105">
		</el-table-column>
        <el-table-column prop="nations" label="代表人群" min-width="110">
		</el-table-column>
		<el-table-column prop="migrationPath" label="迁徙路径" min-width="105">
		</el-table-column>
		<el-table-column prop="migrationPathPicture" label="路线图" min-width="105">
		</el-table-column>
	</el-table>
	<h3>迁徙路线：</h3>
	<el-table :data='migrationPathMap' stripe style="width: 100%" max-height="500" border>
		<el-table-column prop="path" label="路线" min-width="60">
		</el-table-column>
		<el-table-column prop="time" label="时间" min-width="105">
		</el-table-column>
		<el-table-column prop="description" label="描述" min-width="155">
		</el-table-column>
	</el-table>
</div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    haplogroups () {
      if (this.tableData[0]) {
        let result = this.tableData[0].haploTypeConfig ? this.tableData[0].haploTypeConfig.haplogroups : []
        result[0].group === '单倍群' && result.shift()
        return result
      }
      return []
    },
    migrationPathMap () {
      if (this.tableData[0]) {
        let result = this.tableData[0].haploTypeConfig ? this.tableData[0].haploTypeConfig.migrationPathMap : {}
        return JSON.stringify(result) !== '{}' ? Object.values(result) : []
      }
      return []
    }
  }

}
</script>

<style lang="less">
.LH{
	.el-table{
		.content-rowspan{
			>div{
				border-bottom: 1px solid #e4e4e4;
			}
			>div:last-child{
				border-bottom: none;
			}
		}
	}
}

</style>
